import { Page } from '@/components/layout/Page';
import { Card, CardContent } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { usePendingInvitations, useAcceptShare, useRejectShare } from '@/hooks/useShares';
import { ShareService } from '@/services/ShareService';
import { formatDate } from '@/lib/utils';

export function InvitationsPage() {
  const { pendingInvitations, isLoading } = usePendingInvitations();
  const acceptShare = useAcceptShare();
  const rejectShare = useRejectShare();

  return (
    <Page className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Invitations</h1>
        <p className="text-sm text-muted-foreground">
          Accept or decline budget sharing invitations
        </p>
      </div>

      {isLoading ? (
        <p className="text-sm text-muted-foreground">Loading invitations…</p>
      ) : pendingInvitations.length === 0 ? (
        <Card>
          <CardContent className="py-8 text-center text-sm text-muted-foreground">
            No pending invitations
          </CardContent>
        </Card>
      ) : (
        <ul className="space-y-3">
          {pendingInvitations.map((invitation) => (
            <li key={invitation.shareId}>
              <Card>
                <CardContent className="p-4 space-y-3">
                  <div>
                    <p className="font-semibold text-foreground">{invitation.budgetName}</p>
                    <p className="text-sm text-muted-foreground">
                      From {invitation.ownerEmail} · {ShareService.getRoleName(invitation.role)} ·{' '}
                      {formatDate(invitation.invitedAt)}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <Button
                      onClick={() => acceptShare.mutate(invitation.shareId)}
                      loading={acceptShare.isPending}
                    >
                      Accept
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => rejectShare.mutate(invitation.shareId)}
                      loading={rejectShare.isPending}
                    >
                      Decline
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </Page>
  );
}
